export default __webpack_public_path__ + "static/media/filled_cook.04223341.svg";